import { render } from "./PostalCardCollection.vue?vue&type=template&id=140ad8d8&scoped=true&ts=true"
import script from "./PostalCardCollection.vue?vue&type=script&lang=ts"
export * from "./PostalCardCollection.vue?vue&type=script&lang=ts"

import "./PostalCardCollection.vue?vue&type=style&index=0&id=140ad8d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140ad8d8"]])

export default __exports__